import * as React from 'react';

import { RootState } from '../store';

import { Dispatch, Action } from 'redux';
import { LOGOUT, TOGGLE_TIMEOUT } from '../store/login';
import { returntypeof } from '../helper';
import { connect } from 'react-redux';

const mapStateToProps = (state: RootState) => ({
    disclaimer: state.login.disclaimer
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    onConfirm: () => {
        dispatch({type: TOGGLE_TIMEOUT})
    },
    onCancel: () => {
        dispatch({type: LOGOUT})
    }
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

type State = {
    seconds_left: number
}

class Login extends React.Component<Props, State> {

    interval: NodeJS.Timeout | undefined;

    constructor(props: Props){
        super(props);

        this.state = {
            seconds_left: 60
        }
    }

    componentDidMount() {
        this.interval = setInterval(this.bumpTime, 1000);
    }

    bumpTime = () => {

        let new_time = this.state.seconds_left - 1;

        if(new_time <= 0) {
            this.props.onCancel();
        } else {
            this.setState({
                seconds_left: new_time
            });
        }
    }

    componentWillUnmount() {
        if(this.interval != undefined) {
            clearInterval(this.interval);
        }
    }


    public render() {

        return (
          /*  <div className="login-container">
                <div className="card">
                    <div className="card-image">
                        <img className="login-image img-responsive" src="/api/asset/logo" />
                    </div>
                    <div className="card-header">
                        <div className="card-title h5">Are you still there?</div>
                    </div>
                    <div className="card-body disclaimer">
                        Looks like you have been inactive for a while. <br />
                        We'll log you out automatically in {this.state.seconds_left} seconds
                    </div>
                    <div className="card-footer">
                        <div className="btn-group btn-group-block">
                        <button className="btn" onClick={this.props.onCancel} >Logout</button>
                        <button className="btn btn-primary" onClick={this.props.onConfirm} >I'm Still Here</button>
                        </div>
                    </div>
                </div>

            </div> */

            <div className="element-section mt-95">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-10 col-lg-8 mx-auto">
                            <div className="card p-5">
                                <div className="row align-items-center pb-50">
                                    <div className="col-6">
                                        <img className="float-left" src="/api/asset/logo" alt="" width="180px" height="auto"></img>
                                    </div>
                                    <div className="col-6">
                                        <img className="float-right" src="/assets/icons/logo.jpg" alt="" width="180px" height="auto"></img>
                                    </div>
                                </div> 

                                <div className="card-body mx-auto">
                                    <h1 className="h4 pb-30">Are you still there?</h1>
                                    
                                    <div className="pb-15">
                                        <p className="pb-15">Looks like you have been inactive for a while. <br />
                                        We'll log you out automatically in {this.state.seconds_left} seconds</p>
                                    </div>
                                </div>

                                <div className="row pb-50 text-center">
                                    <div className="col-6">
                                        <button className="btn btn-dark btn-terms" onClick={this.props.onCancel}><img src="/assets/icons/cancel.png" width="20px" height="auto" /> Logout</button>
                                    </div>
                                    <div className="col-6">
                                        <button type="button" className="btn btn-primary btn-terms" onClick={this.props.onConfirm} ><img src="/assets/icons/agree.png" width="20px" height="auto" />I'm Still Here</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )

    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Login);